var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registerbox"},[_c('v-time-down-panel',{attrs:{"time":10,"text":"密码重置成功","btnText":"返回登录","show":_vm.panelShow},on:{"end":_vm.onClick,"click":_vm.onClick,"update:show":function($event){_vm.panelShow=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }